import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

type Column<T> = {
  title: string;
  className?: string;
  render: (row: T) => React.ReactNode;
};

interface TabTableProps<T> {
  columns: Column<T>[];
  data: T[];
  emptyMessage?: string;
}

export function TabTable<T>({ columns, data, emptyMessage = "No records found." }: TabTableProps<T>) {
  if (!data.length) {
    return (
      <div className="text-center py-8 text-sm text-gray-500">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((col, idx) => (
              <TableHead key={idx} className={col.className}>
                {col.title}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((row, idx) => (
            <TableRow key={idx}>
              {columns.map((col, cIdx) => (
                <TableCell key={cIdx} className={col.className}>
                  {col.render(row)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
